import axios from 'axios'
import {NOTIFICATION_WARNING} from "../../constants/common";
// initial state
const state = {
    visibleControlsId: null,
    types: [],
    favorite : [],
    history: [],
    training: [],
    tests: []
};

// getters
const getters = {

};

// actions
const actions = {
    getFavoriteItems({commit}) {
        return new Promise((resolve) => {
        axios.get('/api/favorites')
            .then((response) => {
                if (!response.data.error) {
                    commit('setFavorite', response.data.favorite);
                    commit('setHistory', response.data.history);
                    commit('setTraining', response.data.training);
                    commit('setTests', response.data.tests);
                    commit('setTypes', response.data.sectionTypes);
                    resolve();
                } else {
                    this.dispatch('pushNotification', {
                        type: NOTIFICATION_WARNING,
                        text: response.data.message,
                        time: 10000
                    })
                }
            })
            .catch((error) => {
                this.dispatch('errorHandler', error)
            });
        });
    },

    removeFavorite({commit}, id) {
        return new Promise((resolve) => {
            axios.get('/api/articles/favorite', {params: {id: id}})
                .then((response) => {
                    if (!response.data.error) {
                        commit('removeFavorite', id);
                        resolve();
                    } else {
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_WARNING,
                            text: response.data.message,
                            time: 10000
                        })
                    }
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
        });
    },

    setFavorite({commit}, value) {
        let result = value.map(x => x.uniqid);
        return new Promise((resolve) => {
            axios.get('/api/favorites/sort', {params: {position: result}})
                .then((response) => {
                    if (!response.data.error) {
                        commit('setFavorite', value);
                        resolve();
                    } else {
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_WARNING,
                            text: response.data.message,
                            time: 10000
                        })
                    }
                })
                .catch((error) => {
                    this.dispatch('errorHandler', error)
                });
        });
    },
};

// mutations
const mutations = {
    setFavorite (state, items) {
        state.favorite = items
    },
    setHistory (state, items) {
        state.history = items
    },
    setTraining (state, items) {
        state.training = items
    },
    setTests (state, items) {
        state.tests = items
    },
    setTypes (state, types) {
        state.types = types
    },
    setControlsVisibility(state, id){
        state.visibleControlsId = id;
    },
    removeFavorite(state, id) {
        let index = state.favorite.findIndex(x => x.id === id);
        if (index> -1) {
            state.favorite.splice(index ,1);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}